import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchfooterproductorcategory } from "../features/footerproductorcategorySlice";

const Addtwosec = () => {
  const dispatch = useDispatch();
  const { footerproduct, status, error } = useSelector(
    (state) => state.footerproduct
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchfooterproductorcategory());
    }
  }, [dispatch, status]);

  const getLinkUrl = (item) => {
    if (item.select_type == 1) {
      if (item.subchildcategory_id) {
        return `/subchildcategory/${item.subchildcategory_id}`;
      } else if (item.subcategory_id) {
        return `/subcategory/${item.subcategory_id}`;
      } else if (item.category_id) {
        return `/category/${item.category_id}`;
      }
    } else if (item.select_type == 2) {
      if (item.product_id) {
        return `/product-details/${item.product_id}`;
      }
    } else if (item.select_type == 3) {
      if (item.classification_id) {
        return `/classification_list/${item.classification_id}`;
      }
    }
  };

  return (
    <div className="addsectwo-bg pt-40 pb-40">
      <div className="container">
        <div className="row">
          {footerproduct[0] && (
            <div className="col-4 add-two-main" data-aos="fade-up">
              <img
                src={footerproduct[0].image}
                alt="addimage"
                className="first-img"
              />
              <div className="add-two-main-contant">
                <h5>{footerproduct[0].name}</h5>
                <Link to={getLinkUrl(footerproduct[0])} className="btn_2">
                  Shop Now &nbsp;
                  <FontAwesomeIcon icon={faCaretRight} />
                </Link>
              </div>
            </div>
          )}

          {footerproduct[1] && (
            <div className="col-4 add-two-main" data-aos="fade-down">
              <img
                src={footerproduct[1].image}
                alt="addimage"
                className="first-img"
              />
              <div className="add-two-main-contant">
                <h5>{footerproduct[1].name}</h5>
                <Link to={getLinkUrl(footerproduct[1])} className="btn_2">
                  Shop Now &nbsp;
                  <FontAwesomeIcon icon={faCaretRight} />
                </Link>
              </div>
            </div>
          )}

          <div className="col-4 right_col">
            <div className="inner_box">
              {footerproduct[2] && (
                <div
                  className="col-12 add-two-grid add-two-main"
                  data-aos="fade-up"
                >
                  <img
                    src={footerproduct[2].image}
                    alt="addimage"
                    className="grid"
                  />
                  <div className="add-two-main-contant">
                    <h5>{footerproduct[2].name}</h5>
                    <Link to={getLinkUrl(footerproduct[2])} className="btn_2">
                      Shop Now &nbsp;
                      <FontAwesomeIcon icon={faCaretRight} />
                    </Link>
                  </div>
                </div>
              )}

              {footerproduct[3] && (
                <div
                  className="col-12 add-two-grid add-two-main"
                  data-aos="fade-down"
                >
                  <img
                    src={footerproduct[3].image}
                    alt="addimage"
                    className="grid"
                  />
                  <div className="add-two-main-contant">
                    <h5>{footerproduct[3].name}</h5>
                    <Link to={getLinkUrl(footerproduct[3])} className="btn_2">
                      Shop Now &nbsp;
                      <FontAwesomeIcon icon={faCaretRight} />
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addtwosec;
